import EDMessage from "./EDMessage.vue";

const install = (Vue) => {
    const instance: any = new EDMessage().$mount();
    // document.body.appendChild(instance.$el);
    instance.$removeDom = (time = 200) => {
        setTimeout(() => {
            if (document.body.contains(instance.$el)) {
                document.body.removeChild(instance.$el);
            }
        }, time);
    };
    Vue.prototype.$edMessage = {};
    ["info", "success", "error", "warning"].forEach((type, index) => {
        Vue.prototype.$edMessage[type] = (data: any, time = 2) => {
            document.body.appendChild(instance.$el);
            if (data instanceof Object) {
                instance.showNotify(data.content, (data.duration == undefined ? 2 : data.duration) * 1000, index);
            } else {
                instance.showNotify(data, time * 1000, index);
            }
        };
    });
    Vue.prototype.$edMessage.destroy = () => instance.removeNotify();
    Vue.prototype.$edMessage.loading = (data: any, time = 2) => {
        if (data instanceof Object) {
            return instance.loadingNotify(data.content, (data.duration == undefined ? 2 : data.duration) * 1000, 4);
        } else {
            return instance.loadingNotify(data, time * 1000, 4);
        }
    };
    Vue.prototype.$edMessage.loadingBar = (data: any, time = 2) => {
        document.body.appendChild(instance.$el);
        if (data instanceof Object) {
            return instance.loadingNotifyWithBar(data.content, (data.duration == undefined ? 2 : data.duration) * 1000, 6);
        } else {
            return instance.loadingNotifyWithBar(data, time * 1000, 6);
        }
    };

    Vue.prototype.$edMessage.showInfoWithExtra = (opt: any) => {
        document.body.appendChild(instance.$el);
        return instance.showInfoWithExtra(opt, 7);
    };
    Vue.prototype.$edMessage.config = (data) => instance.config(data);
};
export default {
    install,
};
